/**
 * API Configuration
 * Centralizes all API endpoints and URLs
 */

// Get API URL from environment variable, fallback to localhost
export const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:8080';

// WebSocket URL (derived from API URL)
export const WS_BASE_URL = API_BASE_URL.replace(/^http/, 'ws');

// API Endpoints
export const API_ENDPOINTS = {
  // Auth
  auth: {
    login: `${API_BASE_URL}/api/auth/login`,
    register: `${API_BASE_URL}/api/auth/register`,
    logout: `${API_BASE_URL}/api/auth/logout`,
  },

  // Restaurant
  restaurant: {
    base: `${API_BASE_URL}/api/restaurants`,
    byId: (id: string) => `${API_BASE_URL}/api/restaurants/${id}`,
    logo: (id: string) => `${API_BASE_URL}/api/restaurants/${id}/logo`,
  },

  // Orders
  orders: {
    base: `${API_BASE_URL}/api/orders`,
    public: `${API_BASE_URL}/api/public/orders`,
    byId: (id: string) => `${API_BASE_URL}/api/orders/${id}`,
  },

  // Menu
  menu: {
    base: `${API_BASE_URL}/api/menu`,
    publicMenu: (slug: string, tableNumber: string) =>
      `${API_BASE_URL}/api/public/menu/${slug}/table/${tableNumber}`,
  },

  // Payments
  payments: {
    base: `${API_BASE_URL}/api/payments`,
    config: `${API_BASE_URL}/api/payment-configuration`,
  },

  // Analytics
  analytics: {
    base: `${API_BASE_URL}/api/analytics`,
    dashboard: `${API_BASE_URL}/api/analytics/dashboard`,
  },

  // Inventory
  inventory: {
    base: `${API_BASE_URL}/api/inventory`,
    dashboard: `${API_BASE_URL}/api/inventory/dashboard`,
  },

  // KDS
  kds: {
    base: `${API_BASE_URL}/api/kds`,
    orders: `${API_BASE_URL}/api/kds/orders`,
  },

  // Tables
  tables: {
    base: `${API_BASE_URL}/api/tables`,
  },
} as const;

// Helper function to build asset URLs (for images, logos, etc.)
export const getAssetUrl = (path: string): string => {
  if (!path) return '';
  if (path.startsWith('http')) return path; // Already absolute URL
  return `${API_BASE_URL}${path.startsWith('/') ? path : `/${path}`}`;
};

// WebSocket endpoints
export const WS_ENDPOINTS = {
  base: `${WS_BASE_URL}/ws`,
  // SockJS requires HTTP/HTTPS URL, not WS/WSS
  sockjs: `${API_BASE_URL}/ws-sockjs`,
} as const;

export default {
  API_BASE_URL,
  WS_BASE_URL,
  API_ENDPOINTS,
  WS_ENDPOINTS,
  getAssetUrl,
};
